import { Card, CardContent, Grid, TextField, Typography } from "@mui/material";
import React from "react";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import { Button } from "react-bootstrap";

const Payments = () => {
  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={3}>
          <Sidebar />
        </Grid>
        <Grid item xs={12} sm={9}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Navbar />
            </Grid>
            <Grid item xs={11}>
              <Typography
                variant="h4"
                gutterBottom
                align="center"
                sx={{ marginTop: "15px" }}
              >
                Payments
              </Typography>
            </Grid>
            <Grid xs={12}>
              <Card>
                <CardContent>
                  <h1 style={{ textAlign: "center" }}>Amount.</h1>
                  <h2 style={{ textAlign: "center" }}>Rs.6000/-</h2>
                </CardContent>
              </Card>
              <Card>
                <CardContent>
                  <div>
                    <Typography variant="h4" className="text-start mt-3">
                      PayOut Request
                    </Typography>

                    <Grid container>
                      <Grid item xs={12} md={6} mt={5}>
                        <div className="text-start">
                          <TextField
                            id="outlined-basic"
                            label="Enter Amt"
                            variant="outlined"
                            type="number"
                          />
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default Payments;
